import { ApplicationRef, ComponentFactoryResolver, EmbeddedViewRef, Injectable, Injector } from '@angular/core';
import { ModalOptions, PopupType } from 'src/app/model/modal-popup.model';

@Injectable({
  providedIn: 'root'
})
export class ModalPopupService {
  private dynamicComponentRef: any = [];
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
  ) { }

  showModal(config: ModalOptions, component: any = null): any {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(this.getComponent(config.type, component));
    const dynamicComponentRef: any = componentFactory.create(this.injector);
    dynamicComponentRef.instance.popupService = this.injector.get(ModalPopupService);
    this.attachConfig(config, dynamicComponentRef);
    this.appRef.attachView(dynamicComponentRef.hostView);
    const childDomElem = (dynamicComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document?.getElementsByTagName('body')[0].appendChild(childDomElem);
    this.dynamicComponentRef.push(dynamicComponentRef);
    return dynamicComponentRef;
  }

  hideModal(): void {
    const dynamicComponentRef: any = this.dynamicComponentRef.pop();
    if (dynamicComponentRef) {
      this.appRef.detachView(dynamicComponentRef.hostView);
      dynamicComponentRef.destroy();
    }
  }

  private attachConfig(config: any, dynamicComponentRef: any): void {
    for (const key in config) {
      if (config.hasOwnProperty(key)) {
        dynamicComponentRef.instance[key] = config[key];
      }
    }
  }

  private getComponent(type: string, component: any): any {
    let popupComponent;
    switch (type) {
      case PopupType.ERROR:
        // popupComponent = ErrorModalPopupComponent;
        break;
      case PopupType.INFO:
        // popupComponent = InfoModalPopupComponent;
        break;
      case PopupType.CUSTOM:
        popupComponent = component;
        break;
    }
    return popupComponent;
  }

  hideModalByRef(dynamicComponentRef: any): void {
    if (dynamicComponentRef) {
      dynamicComponentRef.remove();
    }
  }
}
